import React from "react";
import { getAccountNameWithLast4 } from "@common/helpers/financialAccount";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { RuleTagRow } from "../RuleTagRow";
import { getDirectionLabel } from "../ruleTagUtils";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleFinancialAccountsCondition: React.FC<Props> = ({
    condition,
}) => {
    const ids = (
        Array.isArray(condition.value) ? condition.value : [condition.value]
    ) as number[];
    const accounts = useFinancialAccounts();
    const accountNames = accounts
        .filter((account) => ids.includes(account.id))
        .map((account) => getAccountNameWithLast4(account, 2));

    if (!accountNames.length) {
        return null;
    }

    const label = getDirectionLabel("Account", condition.transferDirection);

    return <RuleTagRow label={label} type="condition" values={accountNames} />;
};
